/**
 * The chip each Pre-billing state wears, in plain words (R2: no engine
 * words on screen). The table's rows (chipFor in PreBilling.tsx) and the
 * "What the states mean" popover (PrebillingStatesLegend.tsx) both read
 * this one map, so the popover shows exactly the chip a row wears.
 */

import type { ChipVariant } from '@/components/primitives/Chip';
import type { BillingReadiness } from '@/lib/prebilling';

export const STATE_CHIP: Record<BillingReadiness, { label: string; variant: ChipVariant }> = {
  // Human-confirmed: affirm, NEVER gold (gold is only the awaiting state).
  ready: { label: 'Ready', variant: 'affirm' },
  // Eligible, awaiting its author's OK. GOLD (caution = the gold family;
  // the design law: gold means one thing, "awaiting your confirm"). The
  // label reads by viewer: chipFor in PreBilling.tsx.
  needs_your_ok: { label: 'Needs your OK', variant: 'caution' },
  // Sent back to its author: neutral (a task elsewhere, not on this tab).
  needs_detail: { label: 'Needs more detail', variant: 'neutral' },
  still_reading: { label: 'Still reading', variant: 'neutral' },
  // The feed's failure family (pepper): an unread note is a gap in the
  // month's billing story, not a quiet fact.
  failed: { label: `Didn't go through`, variant: 'risk' },
};

/** The awaiting chip names whose OK it waits for: the author's own row
 *  reads "Needs your OK"; anyone else's reads "Waiting for the care
 *  manager", in the same gold. */
export const WAITING_CHIP = { label: 'Waiting for the care manager', variant: 'caution' } as const satisfies {
  label: string;
  variant: ChipVariant;
};
